import {connect} from 'react-redux';
import ContentItemViewArtworkContainer from './ContentItemViewArtworkContainer';
import {
    getContentItemViewArtworkAction,
    resetContentItemViewArtworkAction,
    setContentItemViewArtworkDeliverableAction,
} from './Redux/ContentItemViewArtworkActions';
import {ArtworkItem} from './ContentItemViewArtworkTypes&Const';

export type ContentItemViewArtworkState = {
    contentItemView: {
        contentItemViewArtwork: {
            artworkImages: ArtworkItem[];
            isLoading: boolean;
        };
    };
};

export const mapState = (state: ContentItemViewArtworkState) => {
    const {contentItemView} = state;
    const {contentItemViewArtwork} = contentItemView;

    return contentItemViewArtwork;
};

const mapDispatch = {
    setArtwork: getContentItemViewArtworkAction,
    resetArtwork: resetContentItemViewArtworkAction,
    setDeliverable: setContentItemViewArtworkDeliverableAction,
};

export default connect(mapState, mapDispatch)(ContentItemViewArtworkContainer);
